import React from "react";
import { SignInScreen } from "../components/auth/sign-in-screen";

const SignIn = () => <SignInScreen />;

SignIn.Layout = ({ children }) => children;
export default SignIn;
